// @ts-nocheck

import React from "react";
import { Box, Typography } from "@mui/material";
import translationNoSubcategory from "./translationNoSubcategory";
import { useLanguage } from "../LanguageContext";

const NoSubCategoriesMessage: React.FC = () => {
  const { language } = useLanguage();
  const t = translationNoSubcategory[language as Language];

  return (
    <>
      <Box
        p={1}
        bgcolor="orange"
        color="white"
        borderRadius="4px"
        textAlign="center"
      >
        <Typography variant="body2">{t.message}</Typography>
      </Box>
    </>
  );
};

export default NoSubCategoriesMessage;
